<iframe #iframeElement [src]="bypassedIframeUrl" sandbox="allow-same-origin allow-scripts allow-modals allow-popups allow-forms allow-downloads" [title]="title" allow="fullscreen">
</iframe>
